
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, Icon, Menu} from "antd";
import BaseComponent from "../../../../../../base/BaseComponent";

export default class Format extends BaseComponent {
    static defaultProps = {configName:"picture"};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            suffix: '格式不限',
            optionFormatList: {
                picture: [],
                video: [],
                audio: [],
                other_file: []
            },
            configNameList: {
                pictureSuffix: 'picture',
                videoSuffix: 'video',
                audioSuffix: 'audio',
                otherFileSuffix: 'other_file',
            },
        }
    }

    componentDidMount() {
        this.getFormatList()
    }

    render() {
        let {configName} = this.props;
        let optionFormatList = this.state.optionFormatList;
        let formatItem = optionFormatList[configName];
        let format =(
            <Menu  style={{marginTop:'7px'}} onClick={({item, key}) => {
                this.selectMenu(key)
            }}>
                {formatItem && formatItem.map(optionFormat =>
                    <Menu.Item style={{background: this.state.suffix === optionFormat.key ? "#e6f7ff" : ""}} value={optionFormat.key} key={optionFormat.key}>{optionFormat.key}</Menu.Item>
                )}
            </Menu>
        )
        return (
            <Dropdown overlay={format} trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {this.state.suffix}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }

    selectMenu(data) {
        this.state.suffix = data;
        this.setState({});
        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall([{type:'suffix', data}])
        }
    };

    getFormatList = () => {
        let {configName} = this.props;
        let {configNameList} = this.state;
        let optionsNames = "pictureSuffix";
        for(let i in configNameList) {
            if(configNameList[i] === configName) {
                optionsNames = i;
                break
            }
        }
        // if(
        //     !(optionsNames &&
        //     configNameList[optionsNames] &&
        //     this.state.optionFormatList[configNameList[optionsNames]] &&
        //     this.state.optionFormatList[configNameList[optionsNames]].length)
        // ) {
            this.request({
                url: `/search-server/search/getListFromConfig?optionsNames=${optionsNames}`,
                method: "get",
                contentType: 'json',
                callBack: (res) => {
                    if(res && res[optionsNames]){
                        this.state.optionFormatList[configNameList[optionsNames]] = res[optionsNames];
                    }
                    this.setState({})
                }
            })
        }
    // }

}